import { QuestionDifficulty } from "services/shortAnswerService/question-types/common";
import { AnyQuestionI } from "services/shortAnswerService/question-types/Question";

export default function isQuestionHard(question: AnyQuestionI) {
  return question.difficulty === QuestionDifficulty.HARD;
}
